import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useOrientation } from "../../hooks/useOrientation";

const Loader = ({ title }: { title?: string }) => {
  const { isPortrait, rotation } = useOrientation();
  return (
    <Stack
      height="100vh"
      alignItems="center"
      rowGap={10}
      justifyContent="center"
      sx={{
        ...(isPortrait ? { transform: `rotate(${rotation}deg)` } : {}),
      }}
    >
      <Stack
        rowGap={2}
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <img
          style={{ objectFit: "contain", width: isPortrait ? "60%" : "40%" }}
          alt="image-logo"
          src="https://datasalesio-imagens.s3.amazonaws.com/logos/prd/0.png"
        />
        {title && <Typography variant="h6">{title}</Typography>}
      </Stack>
    </Stack>
  );
};

export default Loader;
